module.exports = __webpack_public_path__ + "static/media/256-georgia.0e4b4d78.svg";